
import { ERR_INVALID_CARD_TYPE } from './ErrorCodes';
import type { Props, JsonWithErrors } from './@types';

export default function collateErrors(
  values: unknown,
  props: Props,
  json: JsonWithErrors,
): { _error: string } {
  const { messages } = props;

  if (!json?.errors?.length) {
    return { _error: messages.errors.unknown() };
  }

  return json.errors.some((error) => error.errorKey === ERR_INVALID_CARD_TYPE)
    ? { _error: messages.errors.cardNotSupported() }
    : { _error: messages.errors.unknown() };
}
